"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUserMFAStatus = exports.webAuthnAuthenticationInitialData = exports.authenticateStepUpMFADetails = exports.secretOTP = exports.secretFileDownload = exports.groupsDetails = exports.userDetails = exports.secretTemplateDetails = exports.secretDetails = exports.secretList = void 0;

var _commonConstants = require("../../../../../../utils/common-constants");

var _constants = require("./constants");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  loading: false,
  result: [],
  pagination: {
    next: '',
    prev: ''
  },
  error: null,
  searchTerm: ''
};
var secretOTPInitialState = {
  otp: '',
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  error: null,
  loadingTime: 0
};

var secretList = function secretList() {
  var _action$payload, _action$payload2, _action$payload3, _action$payload4;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.secretListTypes.SECRET_LIST_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });

    case _constants.secretListTypes.SECRET_LIST_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        result: _toConsumableArray((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.secretListData),
        pagination: (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.secretListPagination,
        loading: false
      });

    case _constants.secretListTypes.SECRET_LIST_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        error: action.payload,
        result: []
      });

    case _constants.secretListTypes.SECRET_LIST_SEARCH_TERM_UPDATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        searchTerm: action.payload
      });

    case _constants.secretListTypes.SECRET_LIST_LOAD_MORE_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });

    case _constants.secretListTypes.SECRET_LIST_LOAD_MORE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: null,
        result: [].concat(_toConsumableArray(state.result), _toConsumableArray((_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.result)),
        pagination: _objectSpread({}, (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.pagination),
        loading: false
      });

    case _constants.secretListTypes.SECRET_LIST_LOAD_MORE_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        error: action.payload
      });

    default:
      return state;
  }
};

exports.secretList = secretList;
var secretDetailsInitialState = {
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  error: null,
  data: {},
  loadingTime: 0
};

var secretDetails = function secretDetails() {
  var _action$payload5;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : secretDetailsInitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.SecretDetailsTypes.SECRET_DETAILS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        error: null
      });

    case _constants.SecretDetailsTypes.SECRET_DETAILS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: _objectSpread(_objectSpread({}, action.payload), {}, {
          loadingTime: undefined
        }),
        error: null,
        loadingTime: ((_action$payload5 = action.payload) === null || _action$payload5 === void 0 ? void 0 : _action$payload5.loadingTime) || 0
      });

    case _constants.SecretDetailsTypes.SECRET_DETAILS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload,
        data: {},
        loadingTime: 0
      });

    case _constants.SecretDetailsTypes.SECRET_DETAILS_RESET:
      return _objectSpread({}, secretDetailsInitialState);

    default:
      return state;
  }
};

exports.secretDetails = secretDetails;
var secretTemplateDetailsInitialState = {
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  error: null,
  data: {},
  loadingTime: 0
};

var secretTemplateDetails = function secretTemplateDetails() {
  var _action$payload6, _action$payload7, _action$payload7$resp;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : secretTemplateDetailsInitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.secretTemplateDetailsTypes.SECRET_TEMPLATE_DETAILS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING
      });

    case _constants.secretTemplateDetailsTypes.SECRET_TEMPLATE_DETAILS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: _objectSpread(_objectSpread({}, action.payload), {}, {
          loadingTime: undefined
        }),
        loadingTime: ((_action$payload6 = action.payload) === null || _action$payload6 === void 0 ? void 0 : _action$payload6.loadingTime) || 0
      });

    case _constants.secretTemplateDetailsTypes.SECRET_TEMPLATE_DETAILS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: (_action$payload7 = action.payload) === null || _action$payload7 === void 0 ? void 0 : (_action$payload7$resp = _action$payload7.response) === null || _action$payload7$resp === void 0 ? void 0 : _action$payload7$resp.data,
        loadingTime: 0
      });

    default:
      return state;
  }
};

exports.secretTemplateDetails = secretTemplateDetails;
var usersInitialState = {
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  error: null,
  data: []
};

var userDetails = function userDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : usersInitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.fetchUsersType.FETCH_USERS_LOADING_VIEW_SECRET:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING
      });

    case _constants.fetchUsersType.FETCH_USERS_SUCCESS_VIEW_SECRET:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: action.payload
      });

    case _constants.fetchUsersType.FETCH_USERS_FAILURE_VIEW_SECRET:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload
      });

    case _constants.fetchUsersType.FETCH_USERS_RESET_VIEW_SECRET:
      return _objectSpread({}, usersInitialState);

    default:
      return state;
  }
};

exports.userDetails = userDetails;
var groupsInitialState = {
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  error: null,
  data: []
};

var groupsDetails = function groupsDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : groupsInitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.fetchGroupsType.FETCH_GROUPS_LOADING_VIEW_SECRET:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING
      });

    case _constants.fetchGroupsType.FETCH_GROUPS_SUCCESS_VIEW_SECRET:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: action.payload
      });

    case _constants.fetchGroupsType.FETCH_GROUPS_FAILURE_VIEW_SECRET:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload
      });

    case _constants.fetchGroupsType.FETCH_GROUPS_RESET_VIEW_SECRET:
      return _objectSpread({}, groupsInitialState);

    default:
      return state;
  }
};

exports.groupsDetails = groupsDetails;
var secretFileDownloadState = {
  data: null,
  error: null,
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  statusCode: null
};

var secretFileDownload = function secretFileDownload() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : secretFileDownloadState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.mySecretFileDownloadTypes.MY_SECRET_FILE_DOWNLOAD_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        statusCode: null,
        error: null
      });

    case _constants.mySecretFileDownloadTypes.MY_SECRET_FILE_DOWNLOAD_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: action.payload,
        error: null,
        statusCode: 200
      });

    case _constants.mySecretFileDownloadTypes.MY_SECRET_FILE_DOWNLOAD_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload,
        statusCode: action.statusCode
      });

    case _constants.mySecretFileDownloadTypes.MY_SECRET_FILE_DOWNLOAD_RESET:
      return _objectSpread({}, secretFileDownloadState);

    default:
      return state;
  }
};

exports.secretFileDownload = secretFileDownload;

var secretOTP = function secretOTP() {
  var _action$payload8, _action$payload9;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : secretOTPInitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.secretOTPTypes.SECRET_OTP_FETCH_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        error: null
      });

    case _constants.secretOTPTypes.SECRET_OTP_FETCH_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        otp: (_action$payload8 = action.payload) === null || _action$payload8 === void 0 ? void 0 : _action$payload8.otp,
        error: null,
        loadingTime: (_action$payload9 = action.payload) === null || _action$payload9 === void 0 ? void 0 : _action$payload9.loadingTime
      });

    case _constants.secretOTPTypes.SECRET_OTP_FETCH_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload,
        otp: '',
        loadingTime: 0
      });

    case _commonConstants.RESOURCE_STATUS.INITIAL:
      return secretOTPInitialState;

    default:
      return state;
  }
};

exports.secretOTP = secretOTP;
var stepUpMFAInitialState = {
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  error: null,
  data: {}
};

var authenticateStepUpMFADetails = function authenticateStepUpMFADetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : stepUpMFAInitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.AuthenticateStepUpMFATypes.SECRET_STEP_UP_MFA_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING
      });

    case _constants.AuthenticateStepUpMFATypes.SECRET_STEP_UP_MFA_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: action.payload,
        error: null
      });

    case _constants.AuthenticateStepUpMFATypes.SECRET_STEP_UP_MFA_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload,
        data: {}
      });

    case _constants.AuthenticateStepUpMFATypes.SECRET_STEP_UP_MFA_FLUSH:
      return _objectSpread({}, stepUpMFAInitialState);

    default:
      return state;
  }
};

exports.authenticateStepUpMFADetails = authenticateStepUpMFADetails;
var initiateWebAuthnAuthenticationInitialState = {
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  error: null,
  data: {}
};

var webAuthnAuthenticationInitialData = function webAuthnAuthenticationInitialData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initiateWebAuthnAuthenticationInitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _commonConstants.stepUpAuthenticationTypes.START_WEB_AUTHN_AUTHENTICATION_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING
      });

    case _commonConstants.stepUpAuthenticationTypes.START_WEB_AUTHN_AUTHENTICATION_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: action.payload
      });

    case _commonConstants.stepUpAuthenticationTypes.START_WEB_AUTHN_AUTHENTICATION_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload
      });

    case _commonConstants.stepUpAuthenticationTypes.START_WEB_AUTHN_AUTHENTICATION_RESET:
      return _objectSpread({}, initiateWebAuthnAuthenticationInitialState);

    default:
      return state;
  }
};

exports.webAuthnAuthenticationInitialData = webAuthnAuthenticationInitialData;
var fetchUserMFAStatusInitialState = {
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  error: null,
  data: {}
};

var fetchUserMFAStatus = function fetchUserMFAStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fetchUserMFAStatusInitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _commonConstants.stepUpAuthenticationTypes.FETCH_USER_MFA_STATUS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING
      });

    case _commonConstants.stepUpAuthenticationTypes.FETCH_USER_MFA_STATUS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: action.payload
      });

    case _commonConstants.stepUpAuthenticationTypes.FETCH_USER_MFA_STATUS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload
      });

    case _commonConstants.stepUpAuthenticationTypes.FETCH_USER_MFA_STATUS_RESET:
      return _objectSpread({}, fetchUserMFAStatusInitialState);

    default:
      return state;
  }
};

exports.fetchUserMFAStatus = fetchUserMFAStatus;